(() => {
  const FILTER_PARAM = 'filter.p.product_type';
  const MENU_SELECTOR = '[data-category-menu] details';
  const LINK_SELECTOR = '[data-category-filter-link]';
  const DROPDOWN_SELECTOR = '[data-category-dropdown]';
  const DYNAMIC_BAR_SELECTOR = '[data-category-bar-dynamic]';
  const CATEGORY_SCROLL_WRAPPER_SELECTOR = '[data-category-scroll-wrapper]';
  const CARET_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 10 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 0 1 0 .708L5.354 5.354a.5.5 0 0 1-.708 0L.646 1.354A.5.5 0 1 1 1.354.646L5 4.293 8.646.646a.5.5 0 0 1 .708 0Z" fill="currentColor"></path></svg>';

  function isModifiedEvent(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;');
  }

  function closeDetails(details) {
    if (!details) return;

    const summary = details.querySelector(':scope > summary');
    details.classList.remove('menu-opening');
    details.removeAttribute('open');

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  function closeCategoryMenu(menu, returnFocus = false) {
    if (!menu) return;

    const summary = menu.querySelector(':scope > summary');
    closeDetails(menu);

    if (returnFocus && summary) {
      summary.focus();
    }
  }

  function closeCategoryDropdown(dropdown, returnFocus = false) {
    if (!dropdown) return;
    const trigger = dropdown.querySelector('[data-category-trigger]');
    const panel = dropdown.querySelector('[data-category-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    clearFloatingPanelStyles(panel);
    dropdown.classList.remove('is-open');

    if (returnFocus) {
      trigger.focus();
    }
  }

  function openCategoryDropdown(dropdown) {
    const trigger = dropdown.querySelector('[data-category-trigger]');
    const panel = dropdown.querySelector('[data-category-panel]');
    if (!trigger || !panel) return;

    document.querySelectorAll(DROPDOWN_SELECTOR).forEach((item) => {
      if (item !== dropdown) closeCategoryDropdown(item);
    });

    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    positionFloatingPanel(panel, trigger);
    dropdown.classList.add('is-open');
  }

  function getCategoryBarRoot(element) {
    return element.closest('[data-category-bar]');
  }

  function positionFloatingPanel(panel, anchor) {
    const categoryBar = getCategoryBarRoot(anchor || panel);
    if (!categoryBar) return;

    const barRect = categoryBar.getBoundingClientRect();
    const top = Math.max(barRect.bottom, 0);

    panel.style.position = 'fixed';
    panel.style.top = `${top}px`;
    panel.style.left = '50%';
    panel.style.right = 'auto';
    panel.style.transform = 'translateX(-50%)';
    panel.style.zIndex = '999';
    panel.style.setProperty('--category-panel-top-offset', `${top}px`);
  }

  function clearFloatingPanelStyles(panel) {
    panel.style.position = '';
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.transform = '';
    panel.style.zIndex = '';
    panel.style.removeProperty('--category-panel-top-offset');
  }

  function updateOpenPanelPositions() {
    document.querySelectorAll(DROPDOWN_SELECTOR).forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-category-trigger]');
      const panel = dropdown.querySelector('[data-category-panel]');
      if (!trigger || !panel || panel.hidden) return;
      positionFloatingPanel(panel, trigger);
    });

    document.querySelectorAll('[data-category-panel-shared]').forEach((panel) => {
      if (panel.hidden) return;
      positionFloatingPanel(panel, panel);
    });
  }

  function closeParentCategoryMenus(element) {
    let current = element.closest('details[open]');

    while (current) {
      closeDetails(current);
      current = current.parentElement.closest('details[open]');
    }
  }

  function closeHeaderDrawer(link) {
    const drawer = link.closest('header-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;

    const details = drawer.querySelector('#Details-menu-drawer-container');
    const summary = details ? details.querySelector('summary') : null;

    if (!details || !summary || !details.hasAttribute('open')) return;

    drawer.closeMenuDrawer(new MouseEvent('click'), summary);
  }

  function mergeSearchParams(targetUrl, currentUrl, filterValue) {
    const params = new URLSearchParams(currentUrl.search);
    const keysToReplace = new Set();

    targetUrl.searchParams.forEach((_, key) => {
      if (key !== FILTER_PARAM) keysToReplace.add(key);
    });

    keysToReplace.forEach((key) => params.delete(key));

    targetUrl.searchParams.forEach((value, key) => {
      if (key !== FILTER_PARAM) params.append(key, value);
    });

    params.set(FILTER_PARAM, filterValue);

    return params.toString();
  }

  function buildFilteredCollectionUrl(link) {
    const currentUrl = new URL(window.location.href);
    const href = link.getAttribute('href') || link.dataset.collectionPath || '/collections/all-products';
    const targetUrl = new URL(href, window.location.origin);
    const destination = new URL(link.dataset.collectionPath || targetUrl.pathname || '/collections/all-products', window.location.origin);
    const filterValue =
      targetUrl.searchParams.get(FILTER_PARAM) ||
      link.dataset.productType ||
      link.dataset.filterLabel ||
      link.textContent.trim();

    destination.search = mergeSearchParams(targetUrl, currentUrl, filterValue.trim());
    destination.hash = targetUrl.hash;

    return `${destination.pathname}${destination.search}${destination.hash}`;
  }

  function handleCategoryLinkClick(event) {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link) return;
    if (isModifiedEvent(event) || link.target === '_blank') return;

    event.preventDefault();

    closeParentCategoryMenus(link);
    closeHeaderDrawer(link);
    closeCategoryDropdown(link.closest(DROPDOWN_SELECTOR));

    window.location.assign(buildFilteredCollectionUrl(link));
  }

  function setupCategoryMenu(menu) {
    const summary = menu.querySelector(':scope > summary');
    const panel = menu.querySelector('[data-category-panel]');

    if (!summary || !panel) return;

    summary.setAttribute('aria-haspopup', 'true');

    menu.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', menu.hasAttribute('open') ? 'true' : 'false');
    });

    menu.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      event.preventDefault();
      closeCategoryMenu(menu, true);
    });

    document.addEventListener('click', (event) => {
      if (!menu.hasAttribute('open')) return;
      if (menu.contains(event.target)) return;

      closeCategoryMenu(menu);
    });

    menu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!menu.hasAttribute('open')) return;
        if (menu.contains(document.activeElement)) return;

        closeCategoryMenu(menu);
      });
    });
  }

  function setupCategoryScroller(wrapper) {
    const scrollArea = wrapper.querySelector('[data-category-scroll-area]');
    const prevButton = wrapper.querySelector('[data-category-scroll-button="prev"]');
    const nextButton = wrapper.querySelector('[data-category-scroll-button="next"]');

    if (!scrollArea || !prevButton || !nextButton) return;

    const updateButtons = () => {
      const maxScrollLeft = scrollArea.scrollWidth - scrollArea.clientWidth;
      const hasOverflow = maxScrollLeft > 8;
      const isAtStart = scrollArea.scrollLeft <= 8;
      const isAtEnd = scrollArea.scrollLeft >= maxScrollLeft - 8;

      prevButton.classList.toggle('is-hidden', !hasOverflow || isAtStart);
      nextButton.classList.toggle('is-hidden', !hasOverflow || isAtEnd);
    };

    const scrollByAmount = (direction) => {
      const distance = Math.max(scrollArea.clientWidth * 0.65, 240);
      scrollArea.scrollBy({
        left: direction * distance,
        behavior: 'smooth',
      });
    };

    prevButton.addEventListener('click', () => scrollByAmount(-1));
    nextButton.addEventListener('click', () => scrollByAmount(1));
    scrollArea.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function init() {
    document.querySelectorAll(MENU_SELECTOR).forEach(setupCategoryMenu);
    document.querySelectorAll(CATEGORY_SCROLL_WRAPPER_SELECTOR).forEach(setupCategoryScroller);
    document.addEventListener('click', handleCategoryLinkClick);
    document.querySelectorAll(DROPDOWN_SELECTOR).forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-category-trigger]');
      const closeButton = dropdown.querySelector('[data-category-close]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        isExpanded ? closeCategoryDropdown(dropdown) : openCategoryDropdown(dropdown);
      });

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          closeCategoryDropdown(dropdown, true);
        });
      }

      dropdown.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        event.preventDefault();
        closeCategoryDropdown(dropdown, true);
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest(DROPDOWN_SELECTOR)) return;
      document.querySelectorAll(DROPDOWN_SELECTOR).forEach((dropdown) => closeCategoryDropdown(dropdown));
    });

    document.addEventListener('focusin', (event) => {
      document.querySelectorAll(DROPDOWN_SELECTOR).forEach((dropdown) => {
        if (dropdown.contains(event.target)) return;
        closeCategoryDropdown(dropdown);
      });
    });

    document.querySelectorAll(DYNAMIC_BAR_SELECTOR).forEach(initDynamicCategoryBar);
    window.addEventListener('resize', updateOpenPanelPositions);
    window.addEventListener('scroll', updateOpenPanelPositions, { passive: true });
  }

  function parseCategoryRawData(raw) {
    const data = new Map();

    raw
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean)
      .forEach((line, index) => {
        if (index === 0 && line.toLowerCase().startsWith('parent')) return;

        const parts = line.split('\t').map((part) => part.trim());
        const parent = parts[0];
        const child1 = parts[1];
        const child2 = parts[2];

        if (!parent) return;
        if (!data.has(parent)) data.set(parent, { directItems: [], groups: new Map() });

        const entry = data.get(parent);

        if (!child1) return;

        if (!child2) {
          if (!entry.directItems.includes(child1)) entry.directItems.push(child1);
          return;
        }

        if (!entry.groups.has(child1)) entry.groups.set(child1, []);
        if (!entry.groups.get(child1).includes(child2)) entry.groups.get(child1).push(child2);
      });

    return Array.from(data.entries()).map(([parent, entry]) => ({
      parent,
      directItems: entry.directItems,
      groups: Array.from(entry.groups.entries()).map(([heading, items]) => ({ heading, items })),
    }));
  }

  function getPanelGroups(entry) {
    const groups = [];

    if (entry.directItems.length) {
      groups.push({ heading: '', items: entry.directItems });
    }

    return groups.concat(entry.groups);
  }

  function distributeGroups(groups, columnCount = 5) {
    const columns = Array.from({ length: columnCount }, () => ({ weight: 0, groups: [] }));

    groups.forEach((group) => {
      const lightestColumn = columns.reduce((smallest, current) =>
        current.weight < smallest.weight ? current : smallest
      );

      lightestColumn.groups.push(group);
      lightestColumn.weight += group.items.length + 1;
    });

    return columns.filter((column) => column.groups.length);
  }

  function renderCategoryPanelColumns(columnsContainer, columns, collectionPath) {
    columnsContainer.innerHTML = columns
      .map(
        (column) => `
          <div class="header-categories-menu__column">
            ${column.groups
              .map(
                (group) => `
                  ${group.heading ? `<p class="header-categories-menu__heading h4">${escapeHtml(group.heading)}</p>` : ''}
                  <ul class="list-unstyled" role="list">
                    ${group.items
                      .map(
                        (item) => `
                          <li>
                            <a
                              href="${collectionPath}?${FILTER_PARAM}=${encodeURIComponent(item)}"
                              class="mega-menu__link link"
                              data-category-filter-link
                              data-category-menu-close
                              data-collection-path="${collectionPath}"
                              data-filter-label="${escapeHtml(item)}"
                            >
                              ${escapeHtml(item)}
                            </a>
                          </li>
                        `
                      )
                      .join('')}
                  </ul>
                `
              )
              .join('')}
          </div>
        `
      )
      .join('');
  }

  function initDynamicCategoryBar(bar) {
    const rawDataElement = bar.querySelector('[data-category-raw]');
    const list = bar.querySelector('[data-category-list]');
    const panel = bar.querySelector('[data-category-panel-shared]');
    const columnsContainer = bar.querySelector('[data-category-columns]');
    const closeButton = bar.querySelector('[data-category-close-shared]');
    const collectionPath = bar.dataset.collectionPath || '/collections/all-products';

    if (!rawDataElement || !list || !panel || !columnsContainer) return;

    const parsedData = parseCategoryRawData(rawDataElement.textContent);
    let activeParent = null;

    list.innerHTML = parsedData
      .map((entry, index) => {
        const panelGroups = getPanelGroups(entry);

        if (!panelGroups.length) {
          return `
            <a
              href="${collectionPath}?${FILTER_PARAM}=${encodeURIComponent(entry.parent)}"
              class="header-category-bar__trigger list-menu__item link focus-inset"
              data-category-filter-link
              data-collection-path="${collectionPath}"
              data-filter-label="${escapeHtml(entry.parent)}"
            >
              <span>${escapeHtml(entry.parent)}</span>
            </a>
          `;
        }

        return `
          <button
            type="button"
            id="HeaderCategoryDynamic-${index + 1}"
            class="header-category-bar__trigger list-menu__item link focus-inset"
            aria-expanded="false"
            data-category-parent="${escapeHtml(entry.parent)}"
          >
            <span>${escapeHtml(entry.parent)}</span>
            <span class="svg-wrapper">${CARET_SVG}</span>
          </button>
        `;
      })
      .join('');

    window.dispatchEvent(new Event('resize'));

    const triggers = Array.from(list.querySelectorAll('[data-category-parent]'));

    function closePanel(returnFocus = false) {
      activeParent = null;
      panel.hidden = true;
      clearFloatingPanelStyles(panel);
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      if (returnFocus) {
        const focusedTrigger = triggers.find((trigger) => trigger.dataset.categoryParent === returnFocus);
        focusedTrigger?.focus();
      }
    }

    function openPanel(parentName) {
      const entry = parsedData.find((item) => item.parent === parentName);
      if (!entry) return;

      const columns = distributeGroups(getPanelGroups(entry));
      renderCategoryPanelColumns(columnsContainer, columns, collectionPath);
      panel.hidden = false;
      positionFloatingPanel(panel, bar);
      activeParent = parentName;
      triggers.forEach((trigger) =>
        trigger.setAttribute('aria-expanded', trigger.dataset.categoryParent === parentName ? 'true' : 'false')
      );
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const parentName = trigger.dataset.categoryParent;
        if (activeParent === parentName) {
          closePanel(parentName);
        } else {
          openPanel(parentName);
        }
      });
    });

    closeButton?.addEventListener('click', () => {
      closePanel(activeParent);
    });

    bar.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      if (panel.hidden) return;
      event.preventDefault();
      closePanel(activeParent);
    });

    document.addEventListener('click', (event) => {
      if (bar.contains(event.target)) return;
      if (panel.hidden) return;
      closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
